module.exports = __webpack_public_path__ + "img/ico.a405cf25.png";